import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'components/ui/toast-store'
import Popup from 'components/Popup'
import TemplateTaskPopup from 'components/popups/TemplateTaskPopup'
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'components/ui/tooltip'
import { Trash2, ListTodo } from 'lucide-react'

import {
	initializeTemplateTasks,
	updateTemplateTask,
	deleteTemplateTask,
} from 'slices/templateSlice'

function TemplateTask({ templateTask }) {
	const templateId = templateTask.templateId
	const templateTaskId = templateTask._id

	const dispatch = useDispatch()

	const [openTaskPopup, setOpenTaskPopup] = useState(false)
	const [popupTitle, setPopupTitle] = useState('Update Task')
	const [recordForEdit, setRecordForEdit] = useState(null)

	const openInPopup = task => {
		setRecordForEdit(task)
		setOpenTaskPopup(true)
	}

	const editTask = async (task, resetForm) => {
		const taskName = task.taskName
		const seq = task.seq
		const taskDays = task.taskDays
		const description = task.description

		dispatch(
			updateTemplateTask({
				_id: task._id,
				templateId: templateId,
				taskName: taskName,
				seq: seq,
				taskDays: taskDays,
				description: description,
			})
		)

		await dispatch(initializeTemplateTasks(templateId))

		resetForm()
		setOpenTaskPopup(false)
		setRecordForEdit(null)
	}

	const deleteTaskHandler = async taskDelete => {
		const id = taskDelete._id

		if (await toast.confirm({ title: 'Delete task', message: 'Delete this task?' })) {
			await dispatch(deleteTemplateTask(id))
		}
	}

	return (
		<div data-testid="DetailsTable" className="group/table">
			<div className="task">
				<div className="task__header">
					<div className="task__info">
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger asChild>
									<h3
										className="cursor-pointer"
										onClick={() => {
											setPopupTitle('Update Task')
											openInPopup(templateTask)
										}}
									>
										{templateTask.seq}
									</h3>
								</TooltipTrigger>
								<TooltipContent>Click to change sequence.</TooltipContent>
							</Tooltip>
						</TooltipProvider>
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger asChild>
									<h2
										key={templateTaskId}
										className="cursor-pointer"
										onClick={() => {
											setPopupTitle('Update Task')
											openInPopup(templateTask)
										}}
									>
										{templateTask.taskName}
									</h2>
								</TooltipTrigger>
								<TooltipContent>{templateTask.description}</TooltipContent>
							</Tooltip>
						</TooltipProvider>
					</div>
					<div className="task__button">
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger asChild>
									<button
										type="button"
										className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors text-blue-600"
										onClick={() => deleteTaskHandler(templateTask)}
									>
										<Trash2 className="h-4 w-4" />
									</button>
								</TooltipTrigger>
								<TooltipContent>Delete Task</TooltipContent>
							</Tooltip>
						</TooltipProvider>
					</div>
				</div>

				{openTaskPopup ? (
					<Popup title={popupTitle} openPopup={openTaskPopup} setOpenPopup={setOpenTaskPopup} icon={<ListTodo className="w-5 h-5" />} description="Edit task details">
						<TemplateTaskPopup recordForEdit={recordForEdit} addEditTask={editTask} />
					</Popup>
				) : null}
			</div>
		</div>
	)
}

export default TemplateTask
